module.exports = __webpack_public_path__ + "public/Icons/loginArrow.svg?40dd4349";